<template>
	<hero-section />
	<main>
		<stats-cards />
		<timetable-section />
		<plans-section />
		<coach-section />
		<gym-section />
		<faq-section />
		<contact-section />
	</main>
	<site-footer />
</template>

<script>
import HeroSection from "./components/site/HeroSection.vue";
import StatsCards from "./components/site/StatsCards.vue";
import TimetableSection from "./components/site/TimetableSection.vue";
import PlansSection from "./components/site/PlansSection.vue";
import CoachSection from "./components/site/CoachSection.vue";
import GymSection from "./components/site/GymSection.vue";
import FaqSection from "./components/site/FaqSection.vue";
import ContactSection from "./components/site/ContactSection.vue";
import SiteFooter from "./components/site/SiteFooter.vue";

export default {
	components: {
		HeroSection,
		StatsCards,
		TimetableSection,
		PlansSection,
		CoachSection,
		GymSection,
		FaqSection,
		ContactSection,
		SiteFooter,
	},
};
</script>
